export default "__VITE_ASSET__CNF6KyrV__"